<script setup lang="ts">
import { ref } from 'vue'

import { Button } from '@collector/shared-ui'
import { useEvent } from '@desktop/views/Relation/composables'

import { buttonClass } from '../consts'
import VerifyResultModal from './VerifyResultModal/VerifyResultModal.vue'

// state
const isModalVisible = ref(false)

// composables
const { isResultVerified } = useEvent()
</script>

<template>
  <Button
    :class="{
      'bg-success-5 border-success-5 hover:bg-success-6 hover:border-success-6 text-neutral-light-10 font-bold':
        isResultVerified,
      [buttonClass]: !isResultVerified,
    }"
    icon="circle-check"
    size="sm"
    iconSize="sm"
    @click="isModalVisible = true"
  >
    <span class="@max-sm:hidden">Results</span>
  </Button>
  <VerifyResultModal
    v-if="isModalVisible"
    @close="isModalVisible = false"
  />
</template>
